package com.loyola.acessoescola

import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.loyola.acessoescola.services.PresentationContext
import com.loyola.acessoescola.services.getQuickAuthClient
import com.loyola.acessoescola.ui.createAddNewViewModel
import com.loyola.acessoescola.ui.createAdminPanelViewModel
import com.loyola.acessoescola.ui.createAppViewModel
import com.loyola.acessoescola.ui.createLoginViewModel
import com.loyola.acessoescola.ui.createRegisteredViwModel
import kotlinx.coroutines.launch



@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val quickAuthClient = getQuickAuthClient(PresentationContext())
    val loginViewModel by lazy { createLoginViewModel(quickAuthClient) }
    val appViewModel by lazy { createAppViewModel(quickAuthClient) }
    val addNewViewModel by lazy { createAddNewViewModel(quickAuthClient) }
    val registeredViewModel by lazy { createRegisteredViwModel(quickAuthClient) }
    val adminPanelViewModel by lazy { createAdminPanelViewModel(quickAuthClient) }

    ComposeViewport {
        val scope = rememberCoroutineScope()

        LaunchedEffect("") {
            scope.launch {
                quickAuthClient.initialize()
            }
        }

        App(
            registeredViewModel = registeredViewModel,
            loginViewModel = loginViewModel,
            appViewModel = appViewModel,
            addNewViewModel = addNewViewModel,
            adminPanelViewModel = adminPanelViewModel
        )
    }
}